import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { ariaDescribedByIds, enumOptionsIsSelected, enumOptionsValueForIndex, optionId } from '@rjsf/utils';
/** The `RadioWidget` is a widget for rendering a radio group.
 *  It is typically used with a string property constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */

function RadioWidget(_ref) {
  var options = _ref.options,
      value = _ref.value,
      required = _ref.required,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      _ref$autofocus = _ref.autofocus,
      autofocus = _ref$autofocus === void 0 ? false : _ref$autofocus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onChange = _ref.onChange,
      id = _ref.id;
  var enumOptions = options.enumOptions,
      enumDisabled = options.enumDisabled,
      inline = options.inline,
      emptyValue = options.emptyValue;
  var handleBlur = useCallback(function (_ref2) {
    var target = _ref2.target;
    return onBlur(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue));
  }, [onBlur, id]);
  var handleFocus = useCallback(function (_ref3) {
    var target = _ref3.target;
    return onFocus(id, enumOptionsValueForIndex(target && target.value, enumOptions, emptyValue));
  }, [onFocus, id]);
  return _jsx("div", {
    className: 'field-radio-group',
    id: id,
    children: Array.isArray(enumOptions) && enumOptions.map(function (option, i) {
      var checked = enumOptionsIsSelected(option.value, value);
      var itemDisabled = Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;
      var disabledCls = disabled || itemDisabled || readonly ? 'disabled' : '';

      var handleChange = function handleChange() {
        return onChange(option.value);
      };

      var radio = _jsxs("span", {
        children: [_jsx("input", {
          type: 'radio',
          id: optionId(id, i),
          checked: checked,
          name: id,
          required: required,
          value: String(i),
          disabled: disabled || itemDisabled || readonly,
          autoFocus: autofocus && i === 0,
          onChange: handleChange,
          onBlur: handleBlur,
          onFocus: handleFocus,
          "aria-describedby": ariaDescribedByIds(id)
        }), _jsx("span", {
          children: option.label
        })]
      });

      return inline ? _jsx("label", {
        className: "radio-inline ".concat(disabledCls),
        children: radio
      }, i) : _jsx("div", {
        className: "radio ".concat(disabledCls),
        children: _jsx("label", {
          children: radio
        })
      }, i);
    })
  });
}

export default RadioWidget;